/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetBidderCustomIdMappingCsv$Params {
  auctionId: number;
  'X-API-Version'?: string;
}

export function getBidderCustomIdMappingCsv(http: HttpClient, rootUrl: string, params: GetBidderCustomIdMappingCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, getBidderCustomIdMappingCsv.PATH, 'get');
  if (params) {
    rb.path('auctionId', params.auctionId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

getBidderCustomIdMappingCsv.PATH = '/api/bidders/auction/{auctionId}/bidder-customid-mapping';
